export interface Category {
  id: number;
  name: string;
  alias: string;
}

export function toCategory(backendCategory: any): Category {
  return {
    id: backendCategory.id,
    name: backendCategory.name_short,
    alias: backendCategory.alias,
  };
}
